import '../index/hero/hero.css';

import React from 'react';
import { navigate } from 'gatsby';
import useIsMobile from '../../hooks/useIsMobile';

const HeroBanner = ({ image, imageMobile, linkTo, imageAlt = 'hero', className = '' }) => {
	const isMobile = useIsMobile();
	const src = isMobile && imageMobile ? imageMobile : image;

	const goToLink = () => {
		if (!linkTo) return;

		const isExternal = linkTo.includes('https');
		if (isExternal) {
			window.open(linkTo, '_blank', 'noopener,noreferrer');
		} else {
			navigate(linkTo);
		}
	};

	return (
		<div
			id="hero-carousel"
			className={`container-lg relative additional-styles ${className}`.trim()}
			style={{
				paddingTop: '10rem',
				overflow: 'hidden',
				maxWidth: 1400
			}}
		>
			<div className="w-full relative">
				<img
					onClick={linkTo ? goToLink : undefined}
					src={src}
					alt={imageAlt}
					style={{
						maxWidth: '100%',
						height: 'auto',
						cursor: linkTo ? 'pointer' : 'default'
					}}
				/>
			</div>
		</div>
	);
};

export default HeroBanner;
